import result from './Result.i18n';

export default result
export { result as Base }
